import * as _ from 'lodash'
import {ICell, ICellMetricUOM, ICubeSource} from "../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import {BehaviorSubject} from "rxjs/Rx";
import {
    WB_SimulationInputRelationshipRow, WB_SimulationMetricsRow,
    WB_SimulationPredictorRelationshipRow
} from "../PA.Core/PAdbSchemaRows";
import {DimensionType} from "../PA.Core/PA.Core.IF.Hierarchy";

export class SimulationComparisonCell
    implements ICell
{
    private _onCellChange: BehaviorSubject<{ Cell: ICell; MetricIds?: string[] }>
    private _cubeSource: ICubeSource

    private _predictorRelRow: WB_SimulationPredictorRelationshipRow
    private _inputRelRow: WB_SimulationInputRelationshipRow
    private _metricRow: WB_SimulationMetricsRow
    private _bMetricValuesLoaded: boolean
    private _cellId: string
    private _simulationId: string
    private _productGroupId: string
    private _periodId: string

    constructor(cubeSource:                  ICubeSource,
                aSimulatorPredictorRelRow:   WB_SimulationPredictorRelationshipRow,
                aSimulatorInputRelRow:       WB_SimulationInputRelationshipRow,
                aSimulatorMetricRow:         WB_SimulationMetricsRow)
    {
        this._cubeSource      = cubeSource
        this._predictorRelRow = aSimulatorPredictorRelRow
        this._inputRelRow     = aSimulatorInputRelRow
        this._metricRow       = aSimulatorMetricRow
        this._onCellChange    = new BehaviorSubject<{Cell: ICell; MetricIds?: string[]}>(undefined)

        this._cellId =  (this._predictorRelRow?.cif?.WB_SIMULATION_PREDICTORR_ID || 'na') + '-' +
            (this._inputRelRow?.cif?.WB_SIMULATION_INPUTR_ID || 'na')

        // Should we check the keys (WB_PRDGRP_ID, WB_PERIOD_ID) are the same between the two rows
        this._simulationId = (this._predictorRelRow?.cif?.WB_SIMULATION_ID || this._inputRelRow?.cif?.WB_SIMULATION_ID || this._metricRow?.cif?.WB_SIMULATION_ID || 'na') + ''
        this._productGroupId = (this._predictorRelRow?.cif?.WB_PRDGRP_ID || this._inputRelRow?.cif?.WB_PRDGRP_ID || this._metricRow?.cif?.WB_PRDGRP_ID || 'na') + ''
        this._periodId = (this._predictorRelRow?.cif?.WB_PERIOD_ID || this._inputRelRow?.cif?.WB_PERIOD_ID || this._metricRow?.cif?.WB_PERIOD_ID || 'na') + ''

        this._bMetricValuesLoaded = true
    }

    get CellId(): string { return this._cellId }
    get bCellEnabled(): boolean { return true };

    get OnCellChange(): BehaviorSubject<{ Cell: ICell; MetricIds?: string[] }> {
        return this._onCellChange
    }

    get bMetricValuesLoaded(): boolean {  return this._bMetricValuesLoaded }

    getCellMetricValue(metricId: string): string | number {
        let metric = this._cubeSource.getMetric(metricId)
        if(_.isEmpty(metric)){
            console.log("Unknown Metric: ", metricId)
            return 0
        }

        switch (metric.Options?.Type){
            case "ModelPredictor":
                if(this._predictorRelRow) {
                    // @ts-ignore
                    return this._predictorRelRow[metricId]
                }
                break

            case "SimulationInput":
                if(this._inputRelRow) {
                    // @ts-ignore
                    return this._inputRelRow[metricId]
                }
                break
            case "SimulationCalcOutputMetric":
                if(this._metricRow) {
                    // @ts-ignore
                    return this._metricRow[metric.MetricFieldName]
                }
                break

        }

        return 0

    }

    getCellMetricUOM(metricId: string): ICellMetricUOM {
        return undefined;
    }

    getKey(dimensionTypeId: string): string {

        switch (dimensionTypeId){
            case DimensionType.PromotionPlan:
                return  this._simulationId

            case DimensionType.Product:
                return this._productGroupId

            case DimensionType.Time:
                return this._periodId
        }
        return ""
    }

    getKeys(): {[dimTypeId: string]: string} {
        return {[DimensionType.PromotionPlan]: this._simulationId,
                [DimensionType.Product]: this._productGroupId,
                [DimensionType.Time]:    this._periodId};
    }

    refreshMetricValues(): Promise<void> | void {
        //-- Nothing to do here
        this._bMetricValuesLoaded = true
        return;
    }

    setCellMetricValue(MetricId: string, value: number | string): void {
        // It's readonly
    }

    rowsMatch(aSimPredictor:   WB_SimulationPredictorRelationshipRow,
              aSimInput:       WB_SimulationInputRelationshipRow,
              aSimMetric:      WB_SimulationMetricsRow): boolean
    {
        if(this._predictorRelRow?.cif?.WB_SIMULATION_PREDICTORR_ID != aSimPredictor?.cif?.WB_SIMULATION_PREDICTORR_ID)
            return false

        if(this._inputRelRow?.cif?.WB_SIMULATION_INPUTR_ID != aSimInput?.cif?.WB_SIMULATION_INPUTR_ID)
            return false

        if(this._metricRow?.cif?.WB_SIMULATION_MT_ID!= aSimMetric?.cif?.WB_SIMULATION_MT_ID)
            return false

        return true
    }

}